<template>
    <div class="breadcrumbs">
        <router-link :to="{ name: 'home'}">ALL PRODUCTS</router-link>

        <template v-if="category">
            &gt;
            <router-link :to="{ name: 'category', params: { categorySlug: category.slug }}">
                {{ category.name.toUpperCase() }}
            </router-link>
        </template>

        <template v-if="subcategory">
            &gt;
            <router-link :to="{ name: 'subcategory', params: { categorySlug: category.slug, subcategorySlug: subcategory.slug }}">
                {{ subcategory.name.toUpperCase() }}
            </router-link>
        </template>
    </div>
</template>

<script>
    export default {

        props: {
            category: Object,
            subcategory: Object,
        }

    }
</script>

<style lang="scss" scoped>

    @import "@/scss/common.scss";

    .breadcrumbs {
        @media (min-width: map-get($grid-breakpoints, "sm" )) {
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }
    }

</style>